import _ from 'lodash';
import { apiFetch, apiRemove, apiSearch } from '../utility';
const apiBase = 'ocrGuide';

const word = 'OCR Document Schema';
const onSuccessRedirectTo = `/ocr/ocrGuides`;

export const getBlockSuggestions = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.getBlockSuggestions`,
			params,
			dispatch,
			callback,
		});
	};
};

export const search = (p = {}) => {
	const { callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			dispatch,
			callback,
		});
	};
};

export const get = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const add = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.add`,
			params,
			dispatch,
			successMessage: `The ${word} was created successfully.
				Click continue to return to the ${word} page.`,
			onSuccessRedirectTo,
			callback,
		});
	};
};

export const update = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			successMessage: `The ${word} updated successfully. 
				Click continue to return to the ${word} page.)`,
			onSuccessRedirectTo,
			callback,
		});
	};
};

export const remove = ({ ocrGuideId, callback = _.noop }) => {
	return (dispatch) => {
		apiRemove({
			base: apiBase,
			id: ocrGuideId,
			dispatch,
			callback,
		});
	};
};
